@if(isDisabled){
<app-loader></app-loader>
}
<form name="TransferOrderToOtherBranchForm" (ngSubmit)="TransferOrderToOtherBranchForm.form.valid && Save()"
    #TransferOrderToOtherBranchForm="ngForm">
    <div class="card">
        <div class="card-header">
            Transfer Order to other Branch
        </div>
        <div class="m-2 card-body">
            <div class="row">
                <div class="col-md-4 px-1">
                    <label>Transfer Order No.</label>
                    <input name="TransferOrderNo" class="form-control" placeholder="" [disabled]="true"
                        [(ngModel)]="Filter.ALLOTMENTID" #PostingOrderNo="ngModel">
                    <div class="invalid-feedback">
                        Please Generate Transfer Order No.
                    </div>
                </div>

                <div class="col-md-3 px-1">
                    <label for="Transactiondate" class="for-label">Transaction Date</label>
                    <input type="date" class="form-control" id="Transactiongdate" name="Transactiongdate"
                        [disabled]="true" [(ngModel)]="Filter.TRANSACTIONDATE">
                    <div class="invalid-feedback">
                        Please select Transaction Date.
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 px-1">
                    <label>Branch <span class="text-danger">*</span></label>
                    <ng-select name="Branch" placeholder="Select Branch" [items]="BranchLoad" bindLabel="BranchName"
                        bindValue="BranchMasterID" [(ngModel)]="Filter.BranchID" (change)="OnBranchChange()"
                        [disabled]="Filter.ID > 0" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Branch.
                    </div>
                </div>
                <div class="col-md-4 px-1">
                    <label>Employee <span class="text-danger">*</span></label>
                    <ng-select name="Employee" placeholder="Select Employee" [items]="EmployeeLoad" bindLabel="Code"
                        bindValue="EmpMasterID" [(ngModel)]="Filter.EMPLOYEEID"
                        (change)="GetDataOnEmployeeLoad(Filter.EMPLOYEEID)" [disabled]="Filter.ID > 0" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Employee.
                    </div>
                </div>

                <div class="col-md-4 px-1">
                    <label>Employee Name <span class="text-danger">*</span></label>
                    <input name="SelectedEmployee" class="form-control" placeholder=""
                        [(ngModel)]="Filter.SelectedEmployee" #PostingOrderNo="ngModel" [disabled]="true" required>
                    <div class="invalid-feedback">
                        Please Select Employee
                    </div>
                </div>

                <div *ngIf="IsSubContractor" class="col-md-4 px-1">
                    <label>Vendor Name</label>
                    <input class="form-control" name="VendorName" placeholder="" [(ngModel)]="Filter.VendorName"
                        [disabled]="true">
                    <div class="invalid-feedback">
                        Please select Employee.
                    </div>
                </div>

                <div class="col-md-4 px-1">
                    <label>Present Customer <span class="text-danger">*</span></label>
                    <input name="PresentCustomer" class="form-control" placeholder="" [(ngModel)]="Filter.FROM_CUSTOMER"
                        #PostingOrderNo="ngModel" [disabled]="true" required>
                    <div class="invalid-feedback">
                        Please Select Present Customer
                    </div>
                </div>

                <div class="col-md-4 px-1">
                    <label>Present Location <span class="text-danger">*</span></label>
                    <input name="PresentLocation" class="form-control" placeholder="" [(ngModel)]="Filter.FROM_SITE"
                        #PostingOrderNo="ngModel" [disabled]="true" required>
                    <div class="invalid-feedback">
                        Please Select Present Location
                    </div>
                </div>

                <div class="col-md-4 px-1">
                    <label>Transfer To Branch<span class="text-danger">*</span></label>
                    <ng-select name="TransferToBranch" placeholder="Select Transfer To Branch"
                        [items]="TransferToBranchLoad" bindLabel="BranchName" bindValue="BranchMasterID"
                        [(ngModel)]="Filter.TO_CUSTOMERID" [disabled]="Filter.ID > 0" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Reason Of Transfer.
                    </div>
                </div>

                <div class="col-md-4 px-1">
                    <label for="Transferdate" class="for-label">Transfer Date</label>
                    <input type="date" class="form-control" id="Transferdate" name="Transferdate"
                        [disabled]="Filter.ID > 0" [(ngModel)]="Filter.FROMDATE">
                    <div class="invalid-feedback">
                        Please select Transfer Date.
                    </div>
                </div>

                <div class="col-md-4 px-1">
                    <label>Remarks <span class="text-danger">*</span></label>
                    <input name="Remarks" class="form-control" placeholder="Remarks" [(ngModel)]="Filter.REMARKS"
                        [disabled]="Filter.ID > 0" #Remarks="ngModel" required>
                    <div class="invalid-feedback">
                        Please Insert Remarks
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col">
                </div>
                <div class="col-auto">
                    <div class="col-auto">
                        <button type="button" class="btn btn-outline-primary btn-sm me-1" (click)="cancel()"
                            [disabled]="isDisabled" ngbTooltip="Cancel" container="body" placement="top">
                            Cancel
                            <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                                aria-hidden="true"></span>
                        </button>

                        <!-- <button type="submit" [ngClass]="{ 'hidden': !this.common.PageRight.IsAdd }"
                            class="btn btn-primary btn-sm me-1" [disabled]="isDisabled || Filter.ID > 0">
                            <i class="bi bi-save2" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled? (Filter.ID > 0 ? 'Edit' : 'Save') :'Loading...'}}
                        </button> -->

                        <button type="submit" class="btn btn-primary btn-sm me-1" [disabled]="isDisabled || Filter.ID > 0">
                            <i class="bi bi-save2" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled? (Filter.ID > 0 ? 'Edit' : 'Save') :'Loading...'}}
                        </button>

                        <button *ngIf="!IsSubContractor" type="button" class="btn btn-outline-primary btn-sm me-1"
                            (click)="TransferOrderToOtherBranchPrint()" [disabled]="isDisabled || Filter.ID == 0"
                            ngbTooltip="Cancel" container="body" placement="top">
                            <i class="bi bi-printer" *ngIf="!isDisabled"></i>
                            Print
                            <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                                aria-hidden="true"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>